module.exports = __webpack_public_path__ + "static/media/logo-m.8b795b90.svg";